module.exports = __webpack_public_path__ + "img/game.bfd80e01.svg";